// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'arcadia', 'arcadia Fallback'"},"className":"__className_e7b750","variable":"__variable_e7b750"};